import { Gunzip } from 'fflate'

/** Uncompress gzipped data with support for multi-member files. */
export default function gunzip(bytes: Uint8Array): Uint8Array[] {
  const members: Uint8Array[] = []
  const gunzipStream = new Gunzip()

  gunzipStream.ondata = (data) => {
    members.push(data)
  }

  gunzipStream.push(bytes)
  return members
}
